/**
 * Apple requires unlocking AI Credits on iOS to go through In-App Purchase
 * (App Review Guideline 3.1.1). App Store Connect consumable product
 * identifiers follow the convention `{PREFIX}{credits}` - e.g. 700 credits
 * is `co.carata.app.aicredit.700`. Keep this prefix in sync with the
 * backend's `appstore.apps.app.product_id_prefix` config value.
 *
 * Both this app and the business app sell AI Credits via IAP, each as its
 * own separate app in App Store Connect with its own Bundle ID and its own
 * product ids - this app's prefix (`co.carata.app.aicredit.`) is what the
 * backend uses to recognise a purchase as coming from here rather than the
 * business app, so there's no need to separately tell it which app this is.
 *
 * Which credit amounts are actually purchasable is NOT hardcoded here -
 * it comes from the backend's `ai_credit_appstore_packages` system
 * setting (delivered as `window.systemConfigs.aiCreditAppStorePackages`,
 * shared with the business app), so packages can change without an app
 * release. Each amount still needs a matching consumable product created
 * in this app's own entry in App Store Connect.
 */
export const APPSTORE_PRODUCT_ID_PREFIX = "co.carata.app.aicredit.";

export function appStoreProductIdForCredits(credits) {
    return `${APPSTORE_PRODUCT_ID_PREFIX}${credits}`;
}

export function availableAppStorePackages() {
    const raw = window.systemConfigs?.aiCreditAppStorePackages ?? [];

    return raw
        .map((credits) => parseInt(credits, 10))
        .filter((credits) => Number.isFinite(credits) && credits > 0);
}
